<script setup lang="ts">
import type { APIIntervals } from '@/types/api'

const filters = useFilters()

const dates: APIIntervals[] = [1, 7, 30]
const selectedDate = computed(() => filters.value.interval)

function changeDate(date: APIIntervals) {
  filters.value = {
    ...filters.value,
    interval: date,
    newest: false,
  }
}
</script>

<script lang="ts">
export default defineComponent({
  name: 'FilterInterval',
})
</script>

<template>
  <PopupMenu>
    <template #default="{ isShown }">
      <AppButton
        variant="clear"
        relative pl-0 pr-0
        class="!text-soft-black"
      >
        <div flex items-center whitespace-nowrap class="gap-[2px] md:gap-1">
          <span class="hidden lg:inline">{{ formatInterval(selectedDate) }}</span>
          <div i-mdi:calendar class="lg:hidden" />

          <div i-mdi:chevron-down text-lg duration-125 transform :class="isShown ? '-rotate-180' : 'rotate-0'" />
        </div>
      </AppButton>
    </template>

    <template #content>
      <AppFloatingMenu
        data-testid="_component=prompt_filters-intervals_selector"
      >
        <ul flex>
          <AppFloatingMenuItem
            v-for="date in dates" :key="date"
            @click="changeDate(date)"
          >
            <Text>{{ formatInterval(date) }}</Text>
          </AppFloatingMenuItem>

          <AppFloatingMenuItem @click="changeDate(0)">
            <Text>All time</Text>
          </AppFloatingMenuItem>
        </ul>
      </AppFloatingMenu>
    </template>
  </PopupMenu>
</template>
